import { useEffect, useState } from 'react';
import { camelizeKeys } from 'humps';

import selectAttributesChartData from '../selectors/attributes-chart-data';
import selectAttributesChartLayers from '../selectors/attributes-chart-layers';

export const fetchData = async (id) => {
  const response = await fetch(`/en-US/my-account/compare/${id}/ranking.json`);
  const comparisonRanking = await response.json();

  return camelizeKeys(comparisonRanking);
};

const useAttributesComparison = ({
  ranking,
  additionalRanking,
  averageRanking,
  comparison,
  config,
  phrases,
  attributePath,
  globalRankings = {},
}) => {
  const [output, setOutput] = useState(undefined);
  const [cache, setCache] = useState({});

  const generateLayersAndAttributes = comparisonRanking => ({
    layers: selectAttributesChartLayers(phrases, config.attributesChartLayers, comparison),
    attributes: selectAttributesChartData(
      ranking,
      comparisonRanking,
      phrases,
      config.attributesChartSortOrder,
      attributePath,
      true,
    ),
    additionalAttributes: selectAttributesChartData(
      additionalRanking,
      comparisonRanking,
      phrases,
      config.attributesChartSortOrder,
      attributePath,
      true,
    ),
  });

  /* eslint-disable react-hooks/exhaustive-deps */
  // While this effect does use the other values provided, we only ever need to rerun the
  // effect when the comparison is changed. Adding _all the things_ as dependencies causes the
  // hook to rerun on every render somehow, so disabling the linter rule feels okay here.
  useEffect(() => {
    if (comparison.id === 'average') {
      setOutput(generateLayersAndAttributes(averageRanking));
    } else if (globalRankings[comparison.id]) {
      setOutput(generateLayersAndAttributes(globalRankings[comparison.id].ranking));
    } else if (cache[comparison.id]) {
      setOutput(generateLayersAndAttributes(cache[comparison.id]));
    } else {
      fetchData(comparison.id).then((comparisonRanking) => {
        setCache({ ...cache, [comparison.id]: comparisonRanking });
        setOutput(generateLayersAndAttributes(comparisonRanking));
      });
    }
  }, [comparison.id]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return output || {};
};

export default useAttributesComparison;
